export default __webpack_public_path__ + "static/media/logo.c34d885f.svg";